import { Constants } from "@eagerdog/constants";

const juniorArmBandClasses = [
  Constants.dog_class_element.junior_showmanship,
];

export { juniorArmBandClasses }
